import { createAuth0Client } from '@auth0/auth0-spa-js';

// Auth0 configuration
const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  authorizationParams: {
    redirect_uri: `${window.location.origin}/callback`,
    audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    scope: 'openid profile email'
  },
  useRefreshTokens: true,
  cacheLocation: 'localstorage'
};

// Debug logging to check environment variables


if (!auth0Config.domain || !auth0Config.clientId) {
  console.error('Missing Auth0 configuration. Please check your environment variables.');
  throw new Error('Auth0 configuration is incomplete - missing domain or client ID');
}

// Validate domain format
if (!auth0Config.domain.includes('.auth0.com') && !auth0Config.domain.includes('.')) {
  console.error('Domain does not appear to be a valid Auth0 domain');
  throw new Error('Invalid Auth0 domain format');
}

// Create and export the Auth0 client
let auth0Client = null;

export const getAuth0Client = async () => {
  if (!auth0Client) {
    auth0Client = await createAuth0Client(auth0Config);
    console.log('Auth0 client created successfully');
  }
  return auth0Client;
};

export default auth0Config; 